import React, { useEffect } from 'react'
import p5js from 'p5'

import {
  Cell,
  CELL_SIZE,
  BACKGROUND_COLOR,
  removeWalls,
} from './maze-generator'
import { CanvasContainer } from './styles'

export default () => {
  useEffect(() => {
    const sketch = (p5) => {
      const grid = []
      const backtrack = []

      let redraw = []
      let current = null
      let columns = 0
      let rows = 0

      p5.setup = () => {
        p5.createCanvas(400, 400)
        columns = p5.floor(p5.width / CELL_SIZE)
        rows = p5.floor(p5.height / CELL_SIZE)
        p5.frameRate(240)

        for (var row = 0; row < rows; row++) {
          for (var col = 0; col < columns; col++) {
            grid.push(new Cell(row, col, p5))
          }
        }

        current = grid[0]
        p5.background(BACKGROUND_COLOR)
      }

      p5.draw = () => {
        current.visited = true
        current.current = true

        const nextCell =
          current && current.checkNeighbors(p5)(grid, rows, columns)

        redraw.push(current)

        current.current = false

        if (nextCell) {
          redraw.push(nextCell)
          backtrack.push(current)
          removeWalls(current, nextCell)
          current = nextCell
        } else if (backtrack.length > 0) {
          current = backtrack.pop()
        } else if (current) {
          current.current = false
          current = null
        }

        redraw.forEach((cell) => cell.show({ p5 }))

        if (!current) {
          p5.background(BACKGROUND_COLOR)
          grid.forEach((cell) => cell.show({ p5 }))
          p5.noLoop()
        }

        redraw = []
      }
    }

    const canvas = window.document.getElementById('container')

    new p5js(sketch, canvas)
  }, [])

  return <CanvasContainer id="container" />
}
